const getDefaultState = () => {
    // if (localStorage.getItem('varCandidates') !== null) {
    //     let cart = JSON.parse(localStorage.getItem('varCandidates'));
    //     return cart
    // } else {
        return {
            cart: []
        }
    // }
}

const state = getDefaultState()

const getters = {
    cart: state => {
        return state.cart
    }
}

const actions = {
    getCart: (state) => {
        if (localStorage.getItem('varCandidates')) {
            let cart = JSON.parse(localStorage.getItem('varCandidates'))
            state.commit('setCart', cart)
        }
    },
    addtoCart(cartItem) {
        state.commit('addCartItem', cartItem)
    }
}

const mutations = {
    setCart (state, cart) {
        state.cart = cart
    },
    addCartItem(state, cartItem) {
        state.cart.push(cartItem)
    },
    deleteCart (state, canId) {
        state.cart = state.cart.filter(obj => obj.pk !== canId)
    }
  } 

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}